//Import REACT components
import React, { Component } from 'react';

//Import admin on rest components
import { GET_LIST, GET_ONE } from 'admin-on-rest';

//import custom rest client
import restClient from '../restClient';
import { Card, CardText } from 'material-ui/Card';
//import customerslist component
import AdDetailsForm from './AdDetails_Form';
import { Link, Router, Route } from 'react-router-dom';

const styles = {
    flex: { display: 'flex', marginBottom: '1em' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em' },
	h1: {marginTop: '0', color: '#284263' },
	descriptionCard: {marginBottom: '25px' },
	a : {color: '#284263' },
	ol: {paddingLeft: '15px', lineHeight: '25px', fontSize: '110%' },
	cardText: { color: '#555', lineHeight: '23px', padding: '20px 20px 5px 20px' }
};

/*

		   	<DomainsSelector nb='Recent ontvangen reviews' domains={domainsList} />
			*/
			
class AdDetails extends Component {
   state = {};

   componentDidMount() {
	   	const { match } = this.props;
		var adId = match.params.adId;
          
		//request data and store in state
        restClient(GET_ONE, 'member/ad_detail', {id: adId})
            .then(response => response.data)
            .then(adDetails => {
                this.setState({ adDetails });
            })
	
    }
	
/* TMP removed: ad form to enter details for ad
<Card style={styles.descriptionCard}>
			 	<CardText style={styles.cardText}>
					<h1 style={styles.h1}>Plaatsings informatie </h1>
					<AdDetailsForm record={adDetails} />	
			   </CardText>
			 </Card>*/

	//render component
    render() {
		const {
            adDetails,
        } = this.state;
       	//component HTML
		return (
		 (typeof adDetails !== 'undefined' &&
         <div>
		 	 <Card style={styles.descriptionCard}>
			 	<CardText style={styles.cardText}>
					<h1 style={styles.h1}>Advertentie toevoegen - Stap 2 van 3</h1>
					<p>U kunt de advertentie in of uitschakelen en de bieding (CPC) wijzigen vanuit het 'Mijn advertenties' overzicht</p>
					<strong>Huidige bieding:</strong> € {adDetails.bid} <br />
					<strong>Status plaatsing:</strong> {adDetails.ad_status} <br />
					<strong>Status advertentie?</strong> {adDetails.ad_active ? 'Ingeschakeld' : 'Uitgeschakeld'} <br />					
			   </CardText>
			 </Card>
			 
			 
         </div>
		 )
          
        );
    }
}

export default AdDetails;



// WEBPACK FOOTER //
// ./src/ads/AdDetails.js